<template>
    <div v-loading="isLoadingJourneys || isLoadingSetting">
        <!-- buttons row -->
        <el-row>
            <el-col :span="24">
                <el-button type="primary" icon="el-icon-refresh-left" @click="loadJourneys">Reload</el-button>
                <el-button type="success">
                    Last update time: {{journeysUpdateTime.format("h:mm a")}} ({{journeysUpdateTimeHuman}})
                </el-button>
                <el-select style="width: 160px" :value="dayRange" @change="updateDayRange">
                    <el-option
                            v-for="item in dayRanges"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
                <el-button style="float: right;" type="primary" @click="goto('/carry-freight/schedule-monitor/tv')">Enter Tv Mode<i class="el-icon-right"></i></el-button>
            </el-col>
        </el-row>
        <br/>
        <!-- table row -->
        <el-row>
            <el-col :span="24">
                <el-table
                        v-if="! isLoadingSetting"
                        style="width: 100%"
                        :data="truckRunningJourneys"
                        :cell-class-name="cellClassName"
                        :show-overflow-tooltip="true"
                        border
                        empty-text="No scheduled trip is being monitored now"
                >
                    <el-table-column
                            prop="name"
                            label="Name"
                            min-width="12%"
                            :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="contractor"
                            label="Contractor"
                            :filters="contractorFilters"
                            :filter-method="filterPlace"
                            filter-placement="bottom"
                            min-width="12%"
                            :show-overflow-tooltip="true"
                    >
                        <template slot-scope="scope">
                            {{scope.row.contractor.name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="originPlace"
                            label="Origin"
                            :filters="originFilters"
                            :filter-method="filterPlace"
                            filter-placement="bottom"
                            min-width="12%"
                            :show-overflow-tooltip="true"
                    >
                        <template slot-scope="scope">
                            {{scope.row.originPlace.name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="destinationPlace"
                            label="Destination"
                            :filters="destinationFilters"
                            :filter-method="filterPlace"
                            filter-placement="bottom"
                            :filtered-value="destFilteredValue"
                            min-width="12%"
                            :show-overflow-tooltip="true"
                    >
                        <template slot-scope="scope">
                            {{scope.row.destinationPlace.name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="truckPlate"
                            label="Truck"
                            :filters="truckFilters"
                            :filter-method="filterEqual"
                            filter-placement="bottom"
                            min-width="11%"
                    ></el-table-column>
                    <el-table-column
                            label="Departure"
                            min-width="15%"
                            sortable
                            sort-by="std"
                    >
                        <template slot-scope="scope">
                            <div>
                                {{getCalendarDate(scope.row.std)}}
                            </div>
                            <div style="float: left;">
                                {{getTime(scope.row.std)}}
                            </div>
                            <div style="float: left;padding: 0 0 0 2px;" :class="[scope.row.atdClass]">
                                {{getTime(scope.row.atd)}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Arrival"
                            min-width="15%"
                            sortable
                            sort-by="sta"
                    >
                        <template slot-scope="scope">
                            <div>
                                {{getCalendarDate(scope.row.sta)}}
                            </div>
                            <div style="float: left;">
                                {{getTime(scope.row.sta)}}
                            </div>
                            <div style="float: left;padding: 0 0 0 2px;" :class="[scope.row.etaOrAtaClass]">
                                {{getTime(scope.row.etaOrAta)}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Status"
                            property="status"
                            :filters="statusFilters"
                            :filter-method="filterStatus"
                            filter-placement="bottom"
                            min-width="20%"
                    >
                        <template slot-scope="scope">
                            {{scope.row.status}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Location"
                            align="center"
                            min-width="15%"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.status.toLowerCase().includes('expected to') && scope.row.latestPoint">
                                <div>
                                    {{scope.row.latestPoint.location.split(',')[0]}}
                                </div>
                                <div>
                                    {{`(${scope.row.latestPoint.speed} km/h)`}}{{scope.row.latestPoint.time.format("h:mma")}}
                                </div>
                                <el-button @click="showMap(scope.row.latestPoint, scope.row.truckPlate)">
                                    Map
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <!-- truck location modal -->
        <el-dialog
                :visible.sync="showMapModal"
                :title="'Truck[' + mapModalTruckPlate + '] Location'"
        >
            <Gmap-Map v-if="showMapModal"
                      style="width: 100%; height: 600px;"
                      map-type-id="roadmap"
                      ref="map"
                      :zoom=11
                      :center="{ lat: this.mapModalPoint.coordinates.coordinates[1], lng: this.mapModalPoint.coordinates.coordinates[0] }">
                <Gmap-Marker
                        :position="{ lat: this.mapModalPoint.coordinates.coordinates[1], lng: this.mapModalPoint.coordinates.coordinates[0] }"
                        @click="showInfoWindow = true"
                        :icon="{
                                path: 1,
                                scale: 3,
                                rotation: Number(mapModalPoint.courseOverGround)
                            }"
                >
                </Gmap-Marker>
                <Gmap-Info-Window
                        v-if="showInfoWindow"
                        :position="{ lat: mapModalPoint.coordinates.coordinates[1] + 0.007, lng: mapModalPoint.coordinates.coordinates[0] }"
                        @closeclick="showInfoWindow = false"
                >
                    {{mapModalPoint.time.format('MMMM Do YYYY, h:mm:ss a')}}
                    <br>{{mapModalPoint.speed}} km/h,
                    <br>{{mapModalPoint.location}}
                </Gmap-Info-Window>
            </Gmap-Map>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        // Do not forget this little guy
        name: 'JourneySchedulesMonitorCarrier',
        // share common functionality with component mixins
        mixins: [],
        // compose new components
        extends: {},
        // component properties/variables
        props: {
        },
        // variables
        data() {
            return {
                dayRanges: [
                    {
                        value: 0,
                        label: 'Last 24 hours'
                    },
                    {
                        value: 1,
                        label: 'Today'
                    },
                    {
                        value: 7,
                        label: 'Last 7 Days'
                    },
                    {
                        value: 30,
                        label: 'Last 30 Days'
                    },
                ],
                momentNow: moment(),
                journeysUpdateTime: moment(),
                showMapModal: false,
                mapModalPoint: '',
                mapModalTruckPlate: '',
                showInfoWindow: true,
                statusFilters: [
                    { text: 'Scheduled', value: 'Scheduled'},
                    { text: 'Departed', value: 'Expected to arrive'},
                    { text: 'Arrived', value: 'Arrived'},
                    { text: 'Cancelled', value: 'Cancelled'},
                ],
            }
        },
        computed: {
            destFilteredValue : function () {
                const setting = this.$store.getters.getTruckRunningSetting;
                let filteredValues = [];
                if (setting && ! setting.subscribe_all) {
                    filteredValues = setting.destination_place_ids;
                }
                return filteredValues;
            },
            journeysUpdateTimeHuman: function () {
                return this.journeysUpdateTime.from(this.momentNow);
            },
            truckRunningJourneys () {
                return this.$store.getters.getTruckRunningJourneys;
            },
            isLoadingJourneys () {
                return this.$store.getters.getTruckRunningJourneysLoadStatus === 1;
            },
            isLoadingSetting () {
                return this.$store.getters.getTruckRunningSettingLoadStatus === 1;
            },
            dayRange () {
                return this.$store.getters.getDayRange;
            },
            truckFilters () {
                const journeys = this.$store.getters.getTruckRunningJourneys;
                let truckPlates = journeys.map(journey => {
                    return journey.truckPlate;
                });
                return this.uniqueArray(truckPlates).sort().map(name => { return {'text': name, 'value': name} });
            },
            contractorFilters () {
                const journeys = this.$store.getters.getTruckRunningJourneys;
                let contractors = journeys.map(journey => journey.contractor);
                contractors = this.uniquePlaces(contractors);
                contractors = this.sortPlaceObjName(contractors);
                return this.uniqueArray(contractors).map(contractor => { return {'text': contractor.name, 'value': contractor.id} });
            },
            originFilters () {
                const journeys = this.$store.getters.getTruckRunningJourneys;
                let originPlaces = journeys.map(journey => journey.originPlace);
                originPlaces = this.uniquePlaces(originPlaces);
                originPlaces = this.sortPlaceObjName(originPlaces);
                return this.uniqueArray(originPlaces).map(place => { return {'text': place.name, 'value': place.id} });
            },
            destinationFilters () {
                const journeys = this.$store.getters.getTruckRunningJourneys;
                let destinationPlaces = journeys.map(journey => journey.destinationPlace);
                destinationPlaces = this.uniquePlaces(destinationPlaces);
                destinationPlaces = this.sortPlaceObjName(destinationPlaces);
                return destinationPlaces.map(place => { return {'text': place.name, 'value': place.id} });
            },
        },
        // when component uses other components
        components: {},
        // methods
        methods: {
            goto(url) {
                location.href = url;
            },
            cellClassName({row, column, rowIndex, columnIndex}) {
                if (column.property === 'status') {
                    return row.statusClasses.join(' ');
                }
            },
            sortPlaceObjName (arr) {
                return arr.sort((a, b) => {
                    if (! a.name || ! b.name) {
                        return 0;
                    }
                    const nameA = a.name.toUpperCase(); // ignore upper and lowercase
                    const nameB = b.name.toUpperCase(); // ignore upper and lowercase
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    // names must be equal
                    return 0;
                })
            },
             uniqueArray (arrArg) {
                return arrArg.filter((elem, pos, arr) => {
                    return arr.indexOf(elem) === pos;
                });
            },
            uniquePlaces (arr) {
                return Array.from(new Set(arr.map(place => place.id)))
                    .map(id => arr.find(place => place.id === id));
            },
            filterPlace (value, row, column) {
                const property = column['property'];
                return row[property]['id'] === value;
            },
            filterEqual (value, row, column) {
                const property = column['property'];
                return row[property] === value;
            },
            filterStatus (value, row) {
                return row.status.includes(value);
            },
            updateDayRange (value) {
                this.$store.dispatch('updateDayRange', value);
                this.loadJourneys();
            },
            loadJourneys () {
                console.log('dispatch load journeys');
                const loadingJourneysMessage = this.$message({
                    message: 'Loading Journeys...',
                    center: true
                });
                this.$store.dispatch('loadTruckRunningJourneys')
                    .then(() => this.journeysUpdateTime = moment())
                    .catch(() => this.$message.error('Sorry, failed to load the journeys.'))
                    .then(() => loadingJourneysMessage.close());
            },
            showMap (latestPoint, truckPlate) {
                this.showMapModal = true;
                this.mapModalPoint = latestPoint;
                this.mapModalTruckPlate = truckPlate;
            },
            getCalendarDate (time) {
                return time ? time.calendar(null, {
                    sameDay: '[]',
                    nextDay: '[Tomorrow]',
                    nextWeek: function callback (now) {
                        return now.isoWeek() === time.isoWeek() ? 'dddd' : '[Next] dddd';
                    },
                    lastDay: '[Yesterday]',
                    lastWeek: function callback (now) {
                        return now.isoWeek() === time.isoWeek() ? 'dddd' : '[Last] dddd';
                    },
                    sameElse: 'Do MMM'
                }) : null;
            },
            getTime (moment = null) {
                if (moment !== null) {
                    return moment.format("h:mma");
                }
                return null;
            },
        },
        // component Lifecycle hooks
        beforeDestroy() {
            clearInterval(this.interval);
            clearInterval(this.reloadInterval);
        },
        created() {
            this.loadJourneys();
            this.reloadInterval = setInterval(() => this.loadJourneys(), 120000);//reload journeys every 2 minutes
            this.interval = setInterval(() => this.momentNow = moment(), 10000); //update moment now every 10 seconds
        },
    };
</script>

<style scoped>
    >>> .text-eta {
        text-decoration: underline;
    }

    >>> .text-on-time {
        color: unset;
    }

    >>> .text-delay-yellow {
        color: #e6a23c;
    }

    >>> .text-delay-red {
        color: #f56c6c;
    }

    >>> .status-cell.on-time {
        background: #67C23A;
    }

    >>> .el-table--enable-row-hover .el-table__body tr:hover>.status-cell.on-time {
        background: #67C23A;
    }

    >>> .status-cell.delay-yellow {
        background: #E6A23C;
    }

    >>> .el-table--enable-row-hover .el-table__body tr:hover>.status-cell.delay-yellow {
        background: #E6A23C;
    }

    >>> .status-cell.delay-red {
        background: #F56C6C;
    }

    >>> .el-table--enable-row-hover .el-table__body tr:hover>.status-cell.delay-red {
        background: #F56C6C;
    }

    >>> svg {
        vertical-align: unset;
    }
</style>

<style scoped>
    label {
        margin-bottom: 0;
    }

    >>> .el-table .cell {
        word-break: normal;
    }
</style>